import { render } from "./OfficialView.vue?vue&type=template&id=82a9499a&scoped=true"
import script from "./OfficialView.vue?vue&type=script&lang=js"
export * from "./OfficialView.vue?vue&type=script&lang=js"

import "./OfficialView.vue?vue&type=style&index=0&id=82a9499a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a9499a"]])

export default __exports__